import registerDiagnostics from '../actions/registerDiagnostics';
import setSessionDetails from '../mutators/setSessionDetails';
import { getDiagnosticsLogState } from '../store/store';
import { lazyGenerateDiagnosticReport } from 'owa-diagnostic-report';
import { renderDiagnosticsInfo } from '../components/DiagnosticsInfo';

export default () => {
    lazyGenerateDiagnosticReport.import().then(util => setSessionDetails(util()));
    registerDiagnostics(
        {
            name: 'Info',
            type: 'Custom',
            datapoints: [],
        },
        getDiagnosticsLogState(),
        () => renderDiagnosticsInfo()
    );
};
